// Categorised FAQs for the /faqs page and reusable FAQ components.

export const faqCategories = [
  {
    id: 'safety',
    title: 'Safety in Russia',
    icon: 'ShieldCheck',
    faqs: [
      {
        q: 'Is Russia safe for Indian medical students?',
        a: 'Yes. Russia is considered one of the safer countries for international students. Universities are located in well-policed cities, campuses are gated and monitored 24×7 by security personnel, and hostels have controlled entry with CCTV. Indian students form large, active communities in every partner university.',
      },
      {
        q: 'How is the safety of female students ensured?',
        a: 'Female students stay in separate hostel blocks or gender-segregated floors. Universities enforce strict entry timings, biometric access, warden presence and emergency assistance. Local police and Indian student unions provide additional support if needed.',
      },
      {
        q: 'Is there any language or cultural barrier that impacts safety?',
        a: 'No. Universities offer a Russian language course during the 1st year so students can handle daily conversations. English is widely understood in and around campus areas. Indian community networks help newcomers settle in comfortably.',
      },
      {
        q: 'What emergency support is available for Indian students?',
        a: 'Russian Education provides an on-ground India-desk in Russia, a 24×7 helpline (+91 95094 06802), coordination with Indian embassies/consulates, and university student welfare officers to handle any medical, legal or personal emergency.',
      },
    ],
  },
  {
    id: 'degree',
    title: 'Degree Recognition',
    icon: 'GraduationCap',
    faqs: [
      {
        q: 'Is the MBBS (MD Physician) degree from Russia recognised in India?',
        a: 'Yes. All 64 partner universities are listed by the World Directory of Medical Schools (WDOMS) and approved by the National Medical Commission (NMC), India. Graduates are eligible to appear for FMGE / NExT and practise medicine in India after clearing it.',
      },
      {
        q: 'Is the degree valid outside India?',
        a: 'Yes. The Russian MD Physician (MBBS-equivalent) is recognised by WHO, ECFMG (USA — USMLE), GMC (UK — PLAB), MCC (Canada), AMC (Australia) and 195+ other countries, allowing graduates to appear for the respective licensing exams.',
      },
      {
        q: 'Which body accredits Russian medical universities?',
        a: 'Russian universities are accredited by the Ministry of Science and Higher Education of the Russian Federation, and additionally by the WHO, WFME (World Federation for Medical Education), IMED / FAIMER (Foundation for Advancement of International Medical Education & Research) and WDOMS.',
      },
    ],
  },
  {
    id: 'nmc-2021',
    title: 'FMG / NMC Regulations 2021 — Russian Compatibility',
    icon: 'ClipboardCheck',
    faqs: [
      {
        q: 'Do Russian universities comply with the NMC (FMG) Regulations 2021?',
        a: 'Yes. Our partner universities offer a continuous 6-year MBBS programme (54 months of study + 12-month in-house internship) delivered in English at the same foreign medical institution — fully aligned with the NMC FMG Regulations 2021.',
      },
      {
        q: 'What are the key NMC 2021 requirements a foreign university must meet?',
        a: '(1) Minimum 54 months of medical education, (2) mandatory 12-month clinical internship at the same institution, (3) English as the medium of instruction, (4) curriculum equivalent to Indian MBBS, and (5) registration of the university with the country’s medical regulator. All our partners meet these criteria.',
      },
      {
        q: 'Is the 1-year internship in Russia counted for NMC eligibility?',
        a: 'Yes. The 12-month rotational internship completed at the Russian university’s teaching hospital is compulsory and counted towards NMC eligibility. After returning to India, a supervised 1-year internship in an NMC-approved hospital is required post-FMGE/NExT before permanent registration.',
      },
      {
        q: 'Are NEET qualification and score mandatory?',
        a: 'Yes. Any Indian student seeking admission to an MBBS course abroad after November 2019 must have qualified NEET-UG and secured admission through it, as required by NMC.',
      },
    ],
  },
  {
    id: 'internship',
    title: 'Internship',
    icon: 'Award',
    faqs: [
      {
        q: 'Where is the internship conducted?',
        a: 'The 12-month internship is completed at the university’s own clinical base hospitals (each partner university has multiple teaching hospitals with 500–2,000+ beds), providing exposure to Medicine, Surgery, OBG, Paediatrics, Emergency, Radiology, Anaesthesia and community medicine.',
      },
      {
        q: 'Can I do part of the internship in India?',
        a: 'The main 12-month rotational internship must be completed at the foreign medical university itself, per NMC 2021 rules. After clearing FMGE / NExT, students must complete a further 1-year supervised internship in an NMC-approved Indian hospital before permanent registration in India.',
      },
      {
        q: 'Is the internship paid?',
        a: 'The internship in Russia is part of the academic programme and is not a paid job. However, students receive clinical exposure, supervised patient handling and rotation through all major departments, making them exam- and practice-ready.',
      },
    ],
  },
  {
    id: 'english-medium',
    title: 'English Medium',
    icon: 'BookOpen',
    faqs: [
      {
        q: 'Is the MBBS course taught entirely in English?',
        a: 'Yes. All 6 years of the MBBS (MD Physician) programme are delivered in English by qualified professors. Course books, lab work, clinical postings and university exams are conducted in English.',
      },
      {
        q: 'Do I need to learn Russian?',
        a: 'A basic Russian language module is included during the first 2–3 years — this is purely to help you communicate with patients during clinical rotations from year 3 onwards. It is not a barrier to academics.',
      },
      {
        q: 'Are professors proficient in English?',
        a: 'Yes. Faculty teaching the international / English-medium batch are selected specifically for their English proficiency and international-teaching experience.',
      },
    ],
  },
  {
    id: 'hostel',
    title: 'Hostel & Accommodation',
    icon: 'HomeIcon',
    faqs: [
      {
        q: 'Is hostel accommodation provided?',
        a: 'Yes. Every partner university provides on-campus or walking-distance hostels with 2–3 students per room, central heating, common kitchen, laundry, Wi-Fi, gym, study room and 24×7 security.',
      },
      {
        q: 'What is the average hostel cost per year?',
        a: 'Hostel rent is highly subsidised and typically ranges from USD 300 to USD 900 per year (about ₹25,000 – ₹75,000), depending on the university and room type.',
      },
      {
        q: 'Is there a separate hostel for female students?',
        a: 'Yes. All universities have separate hostel blocks or floors for female students with dedicated warden and biometric access.',
      },
      {
        q: 'Can I choose private off-campus accommodation?',
        a: 'Yes. From the 2nd year onwards, students may opt for private apartments or shared flats near campus. Our team assists with rental agreements, verification and utilities.',
      },
    ],
  },
  {
    id: 'indian-food',
    title: 'Indian Food',
    icon: 'Utensils',
    faqs: [
      {
        q: 'Will I get Indian food in Russia?',
        a: 'Yes. Most universities have Indian messes run by Indian students/staff serving veg and non-veg Indian meals daily. Additionally, Indian restaurants, tiffin services and grocery stores stocking Indian spices, atta, dal and rice are available in every city.',
      },
      {
        q: 'Can I cook Indian food in the hostel?',
        a: 'Yes. Hostels are equipped with common kitchens and cooking facilities. Students routinely cook Indian meals themselves — Indian grocery stores stock everything from Basmati rice to MDH/Everest masalas and Patanjali items.',
      },
      {
        q: 'Are pure-vegetarian and Jain food options available?',
        a: 'Yes. Indian messes offer pure-veg options daily, and students who follow Jain or specific dietary preferences can easily cook or arrange tiffin from vegetarian Indian caterers.',
      },
      {
        q: 'How much does an Indian meal cost?',
        a: 'A full Indian meal (dal, rice, sabzi, chapati) at the university mess costs approximately ₹120–₹180 per meal. Monthly Indian tiffin packages range from ₹8,000 to ₹12,000.',
      },
    ],
  },
];

// FAQs for individual University detail pages — reusable across all 64 universities.
// `uni` is the university object from data/mock.js so answers stay personalised.
export function buildUniversityFaqs(uni) {
  const name = uni.name;
  const city = uni.city;
  return [
    {
      q: `Is the MBBS at ${name} taught in English?`,
      a: `Yes. ${name} offers a 6-year MD Physician (MBBS-equivalent) programme in an English-medium batch specifically designed for Indian and international students. All lectures, practicals, textbooks and exams are in English.`,
    },
    {
      q: `Is hostel accommodation available at ${name}?`,
      a: `Yes. ${name} provides on-campus or walking-distance hostels with 2–3 students per room, central heating, Wi-Fi, common kitchen, laundry, gym and 24×7 security. Separate female blocks are available.`,
    },
    {
      q: `Is Indian food available near ${name}?`,
      a: `Yes. Indian students at ${name} have easy access to Indian food — the university mess offers Indian meals, and ${city} has multiple Indian restaurants, tiffin services and grocery stores stocking Indian spices, atta, rice and dal.`,
    },
    {
      q: `Why is Russia one of the best study-abroad destinations for MBBS?`,
      a: `Russia offers WHO/NMC-recognised medical degrees, low tuition (₹3–5 lakh per year), zero donation, English-medium 6-year programmes, world-class clinical exposure, safe cities, active Indian student communities and eligibility for USMLE, PLAB and FMGE/NExT.`,
    },
    {
      q: `What is the university infrastructure like at ${name}?`,
      a: `${name} maintains modern academic blocks with digitised smart classrooms, anatomy museums, cadaver labs, simulation labs, molecular biology and biochemistry laboratories, a well-stocked medical library and dedicated OSCE assessment centres — all conforming to European medical-education standards.`,
    },
    {
      q: `Does ${name} have its own clinical-base hospital?`,
      a: `Yes. ${name} is affiliated with multiple clinical-base teaching hospitals (500–2,000+ beds) in ${city}, giving students high patient-load exposure across Medicine, Surgery, OBG, Paediatrics, Emergency, Trauma, Radiology and specialty departments from year 3 onwards.`,
    },
    {
      q: `How does clinical rotation work at ${name}?`,
      a: `Clinical rotations begin from the 3rd year and run through to the 6-year internship. Students rotate through every major department at the university’s teaching hospitals under senior clinicians — building hands-on patient assessment, procedural and diagnostic skills that align with NMC / FMGE requirements.`,
    },
  ];
}
